<template>
  <div>
    <div class="topTitle">
      <span style="font-family:'PingFangBold';color:#333333;font-size: 16px;">教务中心</span>
      / 班级管理
    </div>
    <div class="class-management">
      <el-tabs v-model="activeName2" @tab-click="handleClick">
        <el-tab-pane label="在读班级" name="first" v-if="$attrs.methodAuthTabView('在读班级')">
          <el-form size="small" :inline="true" ref="ruleForm" :model="ruleForm" style="margin-top: 10px" @submit.native.prevent>
            <el-form-item label="班级名称:">
              <el-input style="width: 250px" clearable v-model="ruleForm.classname" placeholder="请输入班级名称" @keyup.enter.native="search"></el-input>
            </el-form-item>

            <el-form-item v-show="moresearch" label="上课老师:" prop="lecturer_id" v-if="
                $attrs.methodAuthTabView('在读班级', '查询') && $attrs.methodAuthTabView('在读班级', '查询').viewScope !== 1
              ">
              <el-select v-model="ruleForm.lecturer_id" style="width: 200px" clearable @change="getClassesList">
                <el-option :label="item.realName + ' ' + '(' + item.name + ')'" :value="item.id" v-for="(item, index) of teacherList1" :key="index"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-button-group>
                <el-button type="primary" @click="search" icon="el-icon-search" v-if="$attrs.methodAuthTabView('在读班级', '查询')">查询</el-button>
                <el-button type="primary" @click="ChangeSearchState" :icon="
                    moresearch ? 'el-icon-caret-bottom' : 'el-icon-caret-top'
                  "></el-button>
              </el-button-group>
            </el-form-item>

            <br />
            <el-form-item v-show="moresearch" label="科目:">
              <el-select v-model="ruleForm.subject_id" placeholder="请选择" clearable style="width: 150px" @change="changesubject">
                <el-option :label="item.name" :value="item.id" v-for="(item, index) of subjectList1" :key="index"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item v-show="moresearch" label="课程体系:">
              <el-select v-model="ruleForm.curriculum_id" placeholder="请选择" style="width: 200px" :disabled="!curriculum_list.length" clearable @change="search">
                <el-option :label="item.curriculumInfo.title" :value="item.curriculumInfo.id" v-for="item of curriculum_list" :key="item.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item v-show="moresearch" label="班级类型:" prop="course_state">
              <el-radio-group v-model="ruleForm.course_state" @change="search">
                <el-radio label="">全部</el-radio>
                <el-radio label="2">试听班</el-radio>
                <el-radio label="1">正式班</el-radio>
                <el-radio label="3">补课班</el-radio>
              </el-radio-group>
            </el-form-item>
            <br />
            <el-form-item label="上课日:">
              <el-checkbox-group @change="search" v-model="ruleForm.typetime">
                <el-checkbox label="1">周一</el-checkbox>
                <el-checkbox label="2">周二</el-checkbox>
                <el-checkbox label="3">周三</el-checkbox>
                <el-checkbox label="4">周四</el-checkbox>
                <el-checkbox label="5">周五</el-checkbox>
                <el-checkbox label="6">周六</el-checkbox>
                <el-checkbox label="7">周日</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-form>
          <el-button icon="el-icon-plus" size="mini" type="primary" @click="singleCreateClass" v-if="$attrs.methodAuthTabView('在读班级', '新建班级')">新建班级</el-button>
          <div class="table-style" style="margin-top:20px;">
            <el-table :data="tableData" :header-cell-style="{
                background: '#f5f7fa',
                color: '#606266',
                'font-size': '14px',
              }" stripe @selection-change="handleSelectionChange">
              <!-- <el-table-column type="selection" width="55"></el-table-column> -->

              <el-table-column align="center" width="50" label="序号" fixed="left">
                <template slot-scope="scope">
                  <span>{{
                    scope.$index + 1 + (page_no - 1) * page_size
                  }}</span>
                </template>
              </el-table-column>

              <el-table-column prop="name" label="班级名称" width="200" fixed="left">
                <template slot-scope="scope">
                  <span style="cursor: pointer;color: #3F9CFB;" @click="DivideStudent(scope.row)">{{ scope.row.name }}</span>
                </template>
              </el-table-column>

              <el-table-column label="类型">
                <template slot-scope="scope">
                  <span v-if="scope.row.curriculum_class_type == '1'">正式班</span>
                  <span v-else-if="scope.row.curriculum_class_type == '2'">试听班</span>
                  <span v-else-if="scope.row.curriculum_class_type == '3'">补课班</span>
                </template>
              </el-table-column>

              <el-table-column label="计费方式">
                <template slot-scope="scope">
                  <span v-if="scope.row.is_cost_lesson_hour">
                    按课时
                  </span>
                  <span v-else>--</span>
                </template>
              </el-table-column>

              <el-table-column align="left" label="科目">
                <template slot-scope="scope">{{
                  scope.row.subject_name
                }}</template>
              </el-table-column>

              <el-table-column align="left" label="课程体系" width="150">
                <template slot-scope="scope">{{
                  scope.row.curriculum_name
                }}</template>
              </el-table-column>

              <el-table-column align="left" prop="" label="上课老师">
                <template slot-scope="scope">
                  <span v-if="scope.row.lecturer_realname != null">{{
                    scope.row.lecturer_realname
                  }}</span>
                  <span v-else>--</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="班级人数">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.student_total_num }}
                  </span>
                </template>
              </el-table-column>

              <el-table-column prop="name" label="课程商品" width="200">
                <template slot-scope="scope">
                  <div v-if="scope.row.classXmGoodsArr.length != 0">
                    <span v-if="scope.row.classXmGoodsArr.length === 1">{{
                      scope.row.classXmGoodsArr[0].xmGoodsInfo.name
                    }}</span>
                    <span v-else>
                      <el-popover placement="top-start" title="" width="200" trigger="hover">
                        <ul>
                          <li v-for="(item, index) in scope.row.classXmGoodsArr" :key="index" style="margin-bottom:10px">
                            {{ item.xmGoodsInfo.name }}
                          </li>
                        </ul>
                        <span slot="reference">
                          {{
                            scope.row.classXmGoodsArr[0].xmGoodsInfo.name
                          }}等{{ scope.row.classXmGoodsArr.length }}项
                        </span>
                      </el-popover>
                    </span>
                  </div>
                  <div v-else>
                    --
                  </div>
                </template>
              </el-table-column>

              <el-table-column align="left" prop="campun_name" label="所属校区" min-width="150"></el-table-column>

              <el-table-column label="操作" width="150" fixed="right" align="center">
                <template slot-scope="scope">
                  <el-button size="small" type="text" @click="UpateClassInfo(scope.row)" :disabled="scope.row.curriculum_class_type===3">编辑</el-button>
                  <el-button size="small" type="text" @click="DivideStudent(scope.row)">管理</el-button>
                  <el-dropdown>
                    <span class="el-dropdown-link">
                      更多
                      <i class="el-icon-arrow-down"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click.native="copyClass(scope.row)">复制班级</el-dropdown-item>
                      <el-dropdown-item v @click.native="updateClassesEndClassState(scope.row)" :disabled="scope.row.curriculum_class_type===3">结业</el-dropdown-item>
                      <el-dropdown-item @click.native="delClasses(scope.row)">删除</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div class="pagination-style">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page_no" :page-sizes="[10, 15, 20, 30, 40, 50, 100]" :page-size="page_size" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="结业班级" name="second" v-if="$attrs.methodAuthTabView('结业班级')">
          <el-form size="small" :inline="true" ref="ruleForm" :model="ruleForm" style="margin-top: 10px" @submit.native.prevent>
            <el-form-item label="班级名称:">
              <el-input style="width: 250px" clearable v-model="ruleForm.classname" placeholder="请输入班级名称" @keyup.enter.native="searchHistory"></el-input>
            </el-form-item>

            <el-form-item v-show="moresearch" label="上课老师:" prop="lecturer_id" v-if="
                $attrs.methodAuthTabView('结业班级', '查询') && $attrs.methodAuthTabView('结业班级', '查询').viewScope !== 1
              ">
              <el-select v-model="ruleForm.lecturer_id" style="width: 200px" clearable @change="searchHistory">
                <el-option :label="item.realName + ' ' + '(' + item.name + ')'" :value="item.id" v-for="(item, index) of teacherList1" :key="index"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-button-group>
                <el-button type="primary" @click="searchHistory" icon="el-icon-search" v-if="$attrs.methodAuthTabView('结业班级', '查询')">查询</el-button>
                <el-button type="primary" @click="ChangeSearchState" :icon="
                    moresearch ? 'el-icon-caret-bottom' : 'el-icon-caret-top'
                  "></el-button>
              </el-button-group>
            </el-form-item>

            <br />
            <el-form-item v-show="moresearch" label="科目:">
              <el-select v-model="ruleForm.subject_id" placeholder="请选择" clearable style="width: 150px" @change="changesubject1">
                <el-option :label="item.name" :value="item.id" v-for="(item, index) of subjectList1" :key="index"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item v-show="moresearch" label="课程体系:" prop="curriculum_id">
              <el-select v-model="ruleForm.curriculum_id" placeholder="请选择" style="width: 200px" :disabled="!curriculum_list.length" clearable @change="searchHistory">
                <el-option :label="item.curriculumInfo.title" :value="item.curriculumInfo.id" v-for="(item, index) of curriculum_list" :key="index"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item v-show="moresearch" label="班级类型:" prop="course_state">
              <el-radio-group v-model="ruleForm.course_state" @change="searchHistory">
                <el-radio label="">全部</el-radio>
                <el-radio label="2">试听班</el-radio>
                <el-radio label="1">正式班</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>

          <div class="table-style">
            <el-table :data="tableData3" :header-cell-style="{
                background: '#f5f7fa',
                color: '#606266',
                'font-size': '14px',
              }" stripe>
              <el-table-column align="center" width="50" label="序号" fixed="left">
                <template slot-scope="scope">
                  <span>{{
                    scope.$index + 1 + (page_no5 - 1) * page_size5
                  }}</span>
                </template>
              </el-table-column>

              <el-table-column prop="name" label="班级名称" width="200">
              </el-table-column>

              <el-table-column label="类型">
                <template slot-scope="scope">
                  <span v-if="scope.row.curriculum_class_type == '1'">正式班</span>
                  <span v-else-if="scope.row.curriculum_class_type == '2'">试听班</span>
                </template>
              </el-table-column>

              <el-table-column label="科目">
                <template slot-scope="scope">{{
                  scope.row.subject_name
                }}</template>
              </el-table-column>

              <el-table-column label="课程体系">
                <template slot-scope="scope">{{
                  scope.row.curriculum_name
                }}</template>
              </el-table-column>

              <el-table-column prop="lecturer_realname" label="上课老师"></el-table-column>

              <el-table-column label="班级人数" prop="student_total_num">
              </el-table-column>
              <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                  <el-button size="small" type="text" @click="updateClassesEndClassState1(scope.row)">取消结业</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div class="pagination-style">
            <el-pagination @size-change="handleSizeChange5" @current-change="handleCurrentChange5" :current-page="page_no5" :page-sizes="[10, 15, 20, 30, 40, 50, 100]" :page-size="page_size5" layout="total, sizes, prev, pager, next, jumper" :total="total5"></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-dialog title="选择关联课程" :visible.sync="dialogVisible" width="50%">
        <div style="overflow: hidden;">
          <div class="fl" style="width: 49%;">
            <div style="margin-bottom: 10px;">选择</div>
            <div style="border: 1px solid #E8E8E8; height: 40vh;border-radius: 5px;overflow-y:auto ;">
              <div style="padding: 10px;background-color: #F7F8F9;">
                <el-input v-model="searchCourse" placeholder="请输入内容课程名称" size="mini">
                  <i slot="suffix" class="el-input__icon el-icon-search" @click="searchCourseList"></i>
                </el-input>
              </div>
              <ul style="padding: 10px;">
                <li v-for="(item, index) in tableDataCourse" :key="index" style="padding: 10px;">
                  <div style="overflow: hidden;">
                    <div class="fl">
                      <el-checkbox @change="changecheckox($event,item)" v-model="item.isShow"></el-checkbox>
                    </div>
                    <div class="fl" style="margin-left: 20px;">
                      {{ item.name }}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="fr" style="width: 49%;">
            <div style="margin-bottom: 10px;">已选</div>
            <el-alert title="班级创建后，排课时会默认主课程为授课课程。" type="warning" show-icon :closable="false">
            </el-alert>
            <div style="border: 1px solid #E8E8E8; height: 35vh;border-radius: 5px;overflow-y:auto; margin-top: 10px; ">
              <div v-for="(item, index) in tagList1" :key="index" style="padding: 10px;" class="showTopping">
                <div style="overflow: hidden;">
                  <div class="fl">
                    <el-tag size="mini">{{ item.tag }}</el-tag>
                    {{ item.name }}
                  </div>
                  <div class="fr">
                    <span class="isShowClass" v-if="item.tag === '次'" style="font-size: 12px; cursor: pointer;" @click="Topping(item)">设为主课</span>
                    <i @click="detaile(item, index)" class="el-icon-error"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>

      <!--学员分班-->
      <el-dialog width="80%" :title="'班级名称:' + CurrentSelectClassName" :visible.sync="dialogFormVisible2">
        <el-row>
          <el-col :span="12">
            <div class="grid-content bg-purple">
              <div>在班学员</div>
              <el-table size="mini" ref="multipleTable" :data="tableData1" tooltip-effect="dark" max-height="600" min-height="600" style="
                    width: 100%;
                    margin-top: 20px;
                    border-left: 1px solid #f5f7fa;
                    border-right: 1px solid #f5f7fa;
                    border-top: 1px solid #f5f7fa;
                  " @selection-change="handleSelectionOutClassStudent" :header-cell-style="{ background: '#f5f7fa' }">
                <el-table-column fixed="left" type="selection" width="55"></el-table-column>
                <el-table-column fixed="left" label="姓名" width="120">
                  <template slot-scope="scope">
                    <span>{{
                      scope.row.studentInfo.studentUserInfo.realname
                    }}</span>
                    <span style="color: #e6a23c" v-if="!scope.row.is_vaild">(已出班)</span>
                  </template>
                </el-table-column>
                <el-table-column prop="studentInfo.name" label="账号" width="120"></el-table-column>
                <el-table-column prop="studentInfo.studentUserInfo.sex" label="性别" show-overflow-tooltip></el-table-column>

                <el-table-column prop="in_class_date" label="入班日期" width="200"></el-table-column>

                <el-table-column prop="out_class_date" label="出班日期" width="200"></el-table-column>
              </el-table>
            </div>
            <!--TODO 出班日期-->
            <div class="pagination-style">
              <el-pagination @current-change="handleCurrentChange1" :current-page.sync="page_no1" layout="total, prev, pager, next" :page-size="page_size1" :total="total1"></el-pagination>
            </div>
          </el-col>
          <el-col :span="3">
            <div style="text-align: center">
              <el-tooltip class="item" effect="dark" content="已缴费学员入班" placement="top">
                <el-button style="margin-top: 80px" size="mini" plain @click="addStudentClassRelation">
                  添加
                  <i class="el-icon-question el-icon--right"></i>
                </el-button>
              </el-tooltip>

              <br />
              <el-tooltip class="item" effect="dark" content="学员移除班级,同时删除未签到讲次" placement="top">
                <el-button style="margin-top: 20px" size="mini" plain @click="delStudentClassRelation">
                  移除
                  <i class="el-icon-question el-icon--right"></i>
                </el-button>
              </el-tooltip>
              <br />
              <el-tooltip class="item" effect="dark" content="跳过缴费操作,直接入班" placement="top">
                <el-button style="margin-top: 20px" size="mini" plain @click="AddMoreStudent">
                  更多
                  <i class="el-icon-question el-icon--right"></i>
                </el-button>
              </el-tooltip>
            </div>
          </el-col>
          <el-col :span="9">
            <div class="grid-content bg-purple">
              <div>已缴费未入班学员</div>
              <div style="
                    margin-top: 20px;
                    border-left: 1px solid #f5f7fa;
                    border-right: 1px solid #f5f7fa;
                    border-top: 1px solid #f5f7fa;
                  ">
                <el-table size="mini" ref="multipleTable" :data="tableData2" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionNoClassStudent" :header-cell-style="{ background: '#f5f7fa' }">
                  <el-table-column fixed="left" type="selection" width="55"></el-table-column>
                  <el-table-column label="姓名">
                    <template slot-scope="scope">
                      {{ scope.row.studentUserInfo.realname }}
                    </template>
                  </el-table-column>

                  <el-table-column label="选择收据" align="center">
                    <template slot-scope="scope">
                      <el-select size="mini" v-model="tableData2[scope.$index].ClassGoodsInfo" placeholder="请选择">
                        <el-option v-for="item of scope.row.stuClassGoodsInfoArr" :key="item.id" :label="
                            (Array(7).join(0) + item.receiptInfo.num).slice(-7)
                          " :value="item"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>

                  <el-table-column label="关联状态" align="center">
                    <template slot-scope="scope">
                      <span v-if="tableData2[scope.$index].ClassGoodsInfo" style="cursor: pointer; color: #409eff" @click="
                          LookReceipt(
                            tableData2[scope.$index].ClassGoodsInfo.receiptInfo
                          )
                        ">查看</span>
                      <span v-else>未关联</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!--TODO 已报名学员 分页-->
              <div class="pagination-style">
                <el-pagination @current-change="handleCurrentChange2" :current-page.sync="page_no2" layout="total, prev, pager, next" :page-size="page_size2" :total="total2"></el-pagination>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-dialog>

      <!--修改班级信息-->
      <el-dialog width="800px" :title="'班级名称:' + updateform.name" :visible.sync="dialogFormVisible7">
        <el-form size="mini" :model="updateform" :rules="rules" ref="form" label-width="100px" label-position="center">
          <el-form-item label="目标校区" required>
            <el-select style="width: 600px" v-model="updateform.educational_institution_campus_id" @change="getCampusSubjectList" disabled>
              <el-option v-for="(item, index) of schoolList" :key="index" :label="item.campusName" :value="item.dept_id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="授课类型" required prop="teaching_type" v-show="false">
            <el-select v-model="updateform.teaching_type" @change="getCampusCurriculumtList" style="width: 600px" disabled>
              <el-option label="面授课" :value="1"></el-option>
              <el-option label="直播课" :value="2"></el-option>
              <el-option label="录播课" :value="3"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="学科" required prop="subject_id">
            <el-select disabled v-model="updateform.subject_id" @change="getCampusCurriculumtList" style="width: 600px">
              <el-option :label="item.name" :value="item.id" v-for="(item, index) of subjectList" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <!-- required prop="curriculum_id" -->
          <el-form-item label="课程体系">
            <el-select v-model="updateform.curriculum_id" @change="getCampusTeacherList" clearable style="width: 600px">
              <el-option :label="item.title" :value="item.id" v-for="item of curriculum_list_class" :key="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="上课老师" required prop="lecturer_id" v-if="$attrs.methodAuthTabView('在读班级', '查询') && $attrs.methodAuthTabView('在读班级', '查询').viewScope !== 1">
            <el-select v-model="updateform.lecturer_id" style="width: 600px" clearable>
              <el-option :label="
                  `${item.realName}(${item.name})${
                    item.platformTch && item.eduTch
                      ? '[平台、校区]'
                      : item.platformTch
                      ? '[平台]'
                      : item.eduTch
                      ? '[校区]'
                      : ''
                  }`
                " :value="item.id" v-for="(item, index) of teacherList" :key="index"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="班级名称" required prop="name">
            <el-input v-model="updateform.name" placeholder="请输入班级名称" style="width: 600px"></el-input>
          </el-form-item>

          <el-form-item label="上课时间" v-show="false">
            <i style="cursor: pointer" class="el-icon-circle-plus" v-if="updateform.weeksinfo.length == 0" @click="AddTime"></i>

            <span>(不会对排课产生影响,只影响班级的显示信息)</span>

            <div style="margin-bottom: 5px" v-for="(item, index) of updateform.weeksinfo" :key="index">
              <el-select v-model="updateform.weeksinfo[index].type" placeholder="请选择" style="width: 100px">
                <el-option label="周一" value="1"></el-option>
                <el-option label="周二" value="2"></el-option>
                <el-option label="周三" value="3"></el-option>
                <el-option label="周四" value="4"></el-option>
                <el-option label="周五" value="5"></el-option>
                <el-option label="周六" value="6"></el-option>
                <el-option label="周日" value="0"></el-option>
              </el-select>

              <el-time-picker style="margin-left: 10px; width: 150px" v-model="updateform.time_strs[index].start_date" placeholder="任意时间点" value-format="HH:mm" :clearable="false"></el-time-picker>
              <el-time-picker style="margin-left: 10px; width: 150px" v-model="updateform.time_strs[index].end_date" placeholder="任意时间点" value-format="HH:mm" :clearable="false"></el-time-picker>

              <i style="margin-left: 10px; cursor: pointer" class="el-icon-delete" @click="DeleteTime(index)"></i>

              <i style="margin-left: 10px; cursor: pointer" class="el-icon-circle-plus" v-if="updateform.weeksinfo.length == index + 1" @click="AddTime"></i>
            </div>
          </el-form-item>

          <el-form-item label="班级类型" prop="curriculum_class_type" required>
            <el-radio-group v-model="updateform.curriculum_class_type">
              <el-radio v-for="item in options1" :key="item.value" :value="item.value" :label="item.value">{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="是否耗费课时:">
            <el-radio v-model="is_cost_lesson_hour" label="1" :disabled="is_cost_lesson_hour1">是</el-radio>
            <el-radio v-model="is_cost_lesson_hour" label="0" :disabled="is_cost_lesson_hour1">否</el-radio>
          </el-form-item>
          <!-- 点名默认消课课时 -->
          <el-form-item label="消课课时:" v-if="is_cost_lesson_hour === '1'">
            <el-input v-model="inputValue" placeholder="请输入" style="width: 200px" oninput="value=value.replace(/[^0-9.]/g,'')" @keydown.native="handleInput2">
              <span slot="suffix">课时</span>
            </el-input>
          </el-form-item>
          <el-form-item label="关联课程:" v-if="is_cost_lesson_hour === '1'">
            <!--  -->
            <div style="width: 200px; padding: 10px;border: 1px solid #DCDFE6; border-radius: 5px;" @click="showCourse">
              <el-tag v-for="(item, index) in tagList1" :key="index" size="mini" style="margin-right: 10px;">
                {{ item.name }}
              </el-tag>
            </div>
          </el-form-item>

          <div style="text-align: right">
            <el-button size="small" @click="dialogFormVisible7 = false">取 消</el-button>
            <el-button size="small" type="primary" @click="updateClasses">修 改</el-button>
          </div>
        </el-form>
      </el-dialog>

      <el-dialog title="收据信息" :visible.sync="DialogVisible" width="80%" top="10vh">
        <div class="dialog-body" v-if="ReceiptData.length > 0" style="margin-bottom: 20px">
          <el-table size="small" ref="classTable" :data="ReceiptData" tooltip-effect="dark" :header-cell-style="{ background: '#f1f7fe' }">
            <el-table-column align="center" label="名称" width="200">
              <template slot-scope="scope">
                <span v-if="scope.row.type == '1'">{{
                  scope.row.curriculumInfo.title
                }}</span>
                <span v-else-if="scope.row.type == '2'">{{
                  scope.row.goodsInfo.name
                }}</span>
                <span v-else>未知</span>
              </template>
            </el-table-column>

            <el-table-column align="center" prop="subject_id" label="班级"></el-table-column>

            <el-table-column align="center" prop="original_unit_price" label="原价"></el-table-column>

            <el-table-column align="center" prop="buy_num" label="数量"></el-table-column>

            <el-table-column align="center" label="单位">
              <template slot-scope="scope">
                <span v-if="scope.row.type == '1'">次</span>
                <span v-else-if="scope.row.type == '2'">{{
                  scope.row.goodsInfo.unit
                }}</span>
                <span v-else>未知</span>
              </template>
            </el-table-column>

            <el-table-column align="center" prop="discount" label="折扣(%)"></el-table-column>

            <el-table-column align="center" label="金额">
              <template slot-scope="scope">{{
                scope.row.now_unit_price * scope.row.buy_num
              }}</template>
            </el-table-column>

            <el-table-column align="center" prop="give_num" label="赠送数量"></el-table-column>
          </el-table>
        </div>

        <el-row>
          <el-col :span="12">
            <div>
              <div style="background: #f1f7fe; color: #606266; padding: 10px">
                <span style="margin-left: 5px">结算信息</span>
              </div>

              <el-row style="padding: 20px">
                <el-col :span="24">
                  <div class="grid-content bg-purple-dark">
                    <el-form size="mini" :model="Current_Receipt" ref="ruleForm" label-width="100px" class="demo-ruleForm" style="bold: 500">
                      <el-form-item label="合计金额">
                        <span>{{ Current_Receipt.total_amount }}</span>
                      </el-form-item>

                      <el-form-item label="直减优惠">
                        <span>{{ Current_Receipt.other_amount }}</span>
                      </el-form-item>

                      <el-form-item label="应交金额">
                        <span>
                          {{
                            Current_Receipt.total_amount -
                              Current_Receipt.other_amount
                          }}
                        </span>
                      </el-form-item>

                      <el-divider></el-divider>

                      <el-form-item label="使用电子钱包">
                        <span>{{ Current_Receipt.bullet_amount }}</span>
                      </el-form-item>

                      <el-form-item label="实交金额">
                        <span>{{ Current_Receipt.final_amount }}</span>
                      </el-form-item>

                      <el-form-item label="收款账户">
                        <div v-for="item of receiptAccountList" :key="item.id">
                          <span>{{ item.accountName }}</span>
                          <span style="margin-left: 10px">{{
                            item.amount
                          }}</span>
                        </div>
                      </el-form-item>
                    </el-form>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="12">
            <div style="background: #f1f7fe; color: #606266; padding: 10px">
              <span style="margin-left: 5px">其他信息</span>
            </div>

            <el-row style="padding: 20px">
              <el-col :span="24">
                <div class="grid-content bg-purple-dark">
                  <el-form size="mini" :model="updateform" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="交费类型">
                      <el-select size="mini" v-model="updateform.charge_type" placeholder="请选择">
                        <el-option v-for="item in shouju_type" :key="item.id" :label="item.name" :value="item.id"></el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label="发票编号">
                      <el-input v-model="updateform.fapiao"></el-input>
                    </el-form-item>

                    <el-form-item label="业绩归属人">
                      <el-select clearable v-model="updateform.leader" placeholder="请选择业绩归属人">
                        <el-option v-for="item in user_list" :key="item.id" :label="item.realname" :value="item.id"></el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label="备注">
                      <el-input type="textarea" v-model="updateform.remark"></el-input>
                    </el-form-item>
                  </el-form>
                </div>
              </el-col>
            </el-row>

            <div></div>
          </el-col>
        </el-row>

        <div slot="footer" style="margin-top: 20px" class="dialog-footer">
          <el-button size="small" @click="DialogVisible = false">关 闭</el-button>
        </div>
      </el-dialog>

      <el-dialog title="全部在读学员" :visible.sync="dialogTableVisible" append-to-body width="80%">
        <el-row :gutter="40">
          <el-col :span="14">
            <div>
              <el-form :inline="true" size="mini" @submit.native.prevent>
                <el-form-item label="姓名">
                  <el-input style="width: 250px" v-model="form3.realname" placeholder="请输入学员姓名" @keyup.enter.native="search"></el-input>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="search3">查询</el-button>
                </el-form-item>
              </el-form>

              <div class="table-style">
                <el-table style="border: 1px solid #f5f7fa" size="mini" :data="gridData" :header-cell-style="{ background: '#f5f7fa' }">
                  <el-table-column fixed="left" width="100" label="姓名" align="center">
                    <template slot-scope="scope">
                      <span>{{ scope.row.studentUserInfo.realname }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column width="150" align="center" prop="name" label="账号"></el-table-column>

                  <el-table-column width="50" align="center" prop="sex" label="性别">
                    <template slot-scope="scope">
                      <span>{{ scope.row.studentUserInfo.sex }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column align="center" label="所在班级" width="300">
                    <template slot-scope="scope">
                      <div v-for="item in scope.row.stuClassArr" :key="item.id">
                        <span>{{ item.classInfo.name }}</span>
                        <br />
                      </div>
                    </template>
                  </el-table-column>

                  <el-table-column width="150" align="center" prop="normal_state" label="学员状态">
                    <template slot-scope="scope">
                      <span v-if="scope.row.normal_state == '1'">试听</span>
                      <span v-else-if="scope.row.normal_state == '2'">在读</span>
                      <span v-else-if="scope.row.normal_state == '3'">休学</span>
                      <span v-else-if="scope.row.normal_state == '4'">已退学</span>
                      <span v-else>未知</span>
                    </template>
                  </el-table-column>

                  <el-table-column fixed="right" align="center" label="操作" width="100">
                    <template slot-scope="scope">
                      <el-button size="mini" type="text" @click="InsertStudent(scope.$index)">选择</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="pagination-style">
                <el-pagination @size-change="handleSizeChange3" @current-change="handleCurrentChange3" :current-page="page_no3" :page-sizes="[10, 15, 20, 30, 40, 50, 100]" :page-size="page_size3" layout="total, sizes, prev, pager, next, jumper" :total="total3"></el-pagination>
              </div>
            </div>
          </el-col>
          <el-col :span="10">
            <div>
              <div>已选学员</div>
              <div>
                <el-table size="mini" :data="gridData2" style="
                      width: 100%;
                      margin-top: 25px;
                      border: 1px solid #f5f7fa;
                    " :header-cell-style="{ background: '#f5f7fa' }">
                  <el-table-column label="姓名" align="center">
                    <template slot-scope="scope">
                      <span>{{ scope.row.studentUserInfo.realname }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="studentUserInfo.sex" label="性别" align="center"></el-table-column>
                  <el-table-column prop="name" label="账号" align="center"></el-table-column>

                  <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                      <el-button type="text" @click="Deleteoutputs(scope.$index)">移除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-col>
        </el-row>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogTableVisible = false">暂不添加</el-button>
          <el-button type="primary" @click="addStudentClassRelationFromAll">加入班级</el-button>
        </span>
      </el-dialog>

      <el-dialog width="80%" title="选择目标班级" :visible.sync="outerVisible2" append-to-body>
        <el-form size="mini" :inline="true" :model="changeform" ref="ruleForm">
          <el-form-item label="班级名称">
            <el-input style="width: 250px" clearable v-model="changeform.className" placeholder="请输入班级名称"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="search1" icon="el-icon-search">查询</el-button>
          </el-form-item>
        </el-form>

        <div>
          <el-table size="mini" :data="stuChange_ClassList" style="width: 100%" highlight-current-row @current-change="SelectTargetClass" :header-cell-style="{ background: '#f5f7fa' }">
            <el-table-column align="center" prop="name" label="班级名称"></el-table-column>

            <el-table-column align="center" prop="start_date" label="开课日期"></el-table-column>

            <el-table-column align="center" prop="end_date" label="结课日期"></el-table-column>

            <el-table-column align="center" label="授课时段">
              <template slot-scope="scope">
                <span>{{ scope.row.week_str }} / {{ scope.row.time_str }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="上课进度">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.sign_tchplan_num }} /
                  {{ scope.row.total_tchplan_num }}
                </span>
              </template>
            </el-table-column>

            <el-table-column align="center" prop="lectureName" label="上课老师"></el-table-column>
          </el-table>

          <div style="margin-top: 20px; text-align: right">
            <el-pagination @current-change="handleCurrentChange4" :current-page="page_no4" :page-size="page_size4" layout="total,prev, pager, next" :total="total4"></el-pagination>
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="outerVisible2 = false">取消</el-button>
          <el-button size="small" type="primary" @click="changeStuClass">确定</el-button>
        </span>
      </el-dialog>
    </div>
    <el-dialog title="删除班级" :visible.sync="dialogVisible3" width="30%">
      <div>
        一旦删除班级，关于班级相关教学计划、作品等信息将会被永久删除。这是一个不可恢复的操作，请谨慎对待!
      </div>
      <div style="margin-top: 20px;">
        <el-input style="width:300px;" v-model="inputTxt" placeholder="请输入「确认删除」，进行下一步操作!"></el-input>
        <el-button style="margin-left:10px;" :disabled="inputTxt === '确认删除' ? false : true" type="danger" @click="delSubmit">删 除</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getCurriculumList,
  getClassesList,
  getEducationalInstitutionCampusList,
  getNotDivideStudentList,
  addStudentClassRelation,
  getClassStudentList,
  delStudentClassRelation,
  getUserCampusList,
  getCampusSubjectList,
  // getCampusTeacherList,
  getCampusCurriculumtList,
  updateClasses,
  // deleteClasses,
  getReceiptChargeGoodsList,
  getReceiptAccountList,
  getCampusUserList,
  getFormalStudentList,
  getClassListForStuChangeClass,
  changeStuClass,
  updateClassesEndClassState,
  getCampusCurriculumtListByPage,
  getXmGoodsListForClassEdit,
  checkReomveXmGoods,
  // getTeacherListByCampusIds,
  getCampusArrSubjectList,
} from '@/api/educational'
import { api_eduCampusSelectTchListByCampus, api_currClsDelete } from '@/api/javaApi'

export default {
  name: 'class-management',

  data() {
    return {
      is_cost_lesson_hour1: null,
      is_cost_lesson_hour: '1',
      page_no7: 1,
      page_size7: 500,
      total7: 0,
      searchCourse: '',
      dialogVisible: false,
      tagList1: [],
      tableDataCourse: [],
      inputValue: '',
      pagename: 'class-management',

      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      options1: [
        {
          value: 2,
          label: '试听班',
        },
        {
          value: 1,
          label: '正式班',
        },
      ],
      delName: '',
      classIds: [],
      inputTxt: '',
      dialogVisible3: false,
      //分页管理
      //班级列表分页
      page_no: 1,
      page_size: 20,
      total: 0,

      //班级学员分页
      page_no1: 1,
      page_size1: 10,
      total1: 0,
      //已报课学员分页
      page_no2: 1,
      page_size2: 20,
      total2: 0,

      //所有学员列表
      page_no3: 1,
      page_size3: 10,
      total3: 0,
      moresearch: true,

      input1: '',
      input2: '',
      input3: '',
      select: '',

      tableData1: [], //班级学员列表
      tableData11: [], //历史学员
      tableData2: [], //未分班学员列表

      dialogTableVisible: false,
      dialogFormVisible: false,
      dialogFormVisible7: false, //修改班级信息

      schoolList: [], //学校信息
      subjectList: [], //科目列表
      subjectList1: [], //科目列表

      curriculum_list: [], //体系列表
      curriculum_list_class: [], //班级课程体系
      teacherList: [], //教师列表
      teacherList1: [], //教师列表

      rules: {
        curriculum_id: [
          {
            required: true,
            message: '请选择课程',
            trigger: 'change',
          },
        ],
        name: [
          {
            required: true,
            message: '请输入班级名称',
            trigger: 'blur',
          },
        ],
        teaching_type: [
          { required: true, message: '请选择课程类型', trigger: 'change' },
        ],
        lecturer_id: [
          { required: true, message: '请选择主讲老师', trigger: 'change' },
        ],
        educational_institution_campus_id: [
          { required: true, message: '请选择校区', trigger: 'change' },
        ],
        sort_num: [
          { required: true, message: '请输入排序号', trigger: 'change' },
        ],
        subject_id: [
          { required: true, message: '请选择学科', trigger: 'change' },
        ],
        curriculum_class_type: [
          { required: true, message: '请选择班级类型', trigger: 'change' },
        ],
      },
      //正式学员续班
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
      user_list: [], //校区员工列表
      shouju_type: [
        {
          id: 1,
          name: '新增',
        },
        {
          id: 2,
          name: '扩科',
        },
        {
          id: 3,
          name: '续费',
        },
        {
          id: 4,
          name: '预存',
        },
      ],

      formLabelWidth: '120px',
      //搜索正式班级
      ruleForm: {
        typetime: [],
        search_type: '',
        lecturer_id: '',
        classname: '',
        search_value: '',
        subject_id: '',
        curriculum_id: '',
        teaching_type: '',
        class_start_time: '',
        class_end_time: '',
        course_type: '',
        course_state: '',
        educational_institution_campus_id: '', //所属校区
        startdate: [], //开班日期
        enddate: [], //结课日期
        end_class_state: '0', // 班级是否结业
      },
      //更新班级信息
      updateform: {
        id: '',
        educational_institution_campus_id: '',
        teaching_type: '',
        curriculum_id: '',
        lecturer_id: '',
        assistant_teacher_id: '',
        name: '',
        weeksinfo: [],
        time_strs: [],
        curriculum_class_type: '',
      },

      classStartTime: '',

      tableData: [],
      tableData3: [],

      //学员续班

      haschoose_teachplan: false,

      //转为正式学员
      haschoose_class: false,
      order_state: '', //学员转公开课试听
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      dialogFormVisible4: false, //跟班试听学员转为正式
      //公开课试听学员
      form1: {
        nickname: '',
        student_user_id: '', //学生ID
        curriculum_class_id: '', //班级ID
        other_goods_list: [], //其他商品列表
        remark: '', //备注
        chooseClassinfo: {},
        chooseGoods: [],
      },
      //退费订单
      form2: {
        original_curriculum_class_price: 0,
        otherGoodsArr: [],
        refund_type: '1',
        remark: '',
      },

      Goodslist: [],
      goodslist: [],

      haschoose_student: false,
      chooseStudentInfo: {},

      outerVisible: false,
      outerVisible1: false,
      curriculum_class_price: '', //班级商品实收价格

      haschoose_good: false, //是否选择了商品

      chooseTeachPlanList: [],
      haschoose_plan: false,
      teaching_plan_list: [],

      total_price: 0,
      total_outprice: 0,
      Audition_StudentData: [],
      Audition_GoodsData: [],

      ClassStudentManagermentData: [], //班级里的试听学员
      ClassOpenStudentManagermentData: [], //跟班试听学员列表
      ClassStudentManagerment: {}, //当前选择的班级
      chooseAuditionClassList: {}, //试听班级信息

      originalCurriculumMeterialList: [], //出勤讲次
      originalCurriculum: {}, //学员报名的课程体系
      originalOrderInfo: {}, //学员退费订单详情
      originalotherGoodsArr: [],
      originalOrder: {}, //

      insign_num: 0,
      sign_num: 0,
      goodprice: 0,

      activeName: 'first', //正式学员列表
      activeName1: 'first', //班级信息TAB
      activeName2: 'first', //开课班级

      curriculum_class_type: '', //班级查询类型  1 正式课程  2试听课程
      NoClassStudents: [], // 未分班学员
      OutClassStudents: [], //即将移除班级的学员
      CurrentSelectClassId: {}, //当前选择的班级
      CurrentSelectClassName: '', //分班的班级名称
      studentIds: [], //选中的学员ID
      outstudentIds: [], //选中即将移除班级的学员
      current_class_id: '',

      hasauth: false,
      chooseClassses: [], //选择的班级列表
      delete_class_id: '', //需要删除的班级id

      ReceiptData: [], //收据商品详情
      receiptAccountList: [], //收据账户详情
      Current_Receipt: {},
      goods_and_course_price: 0,
      DialogVisible: false,

      studentDataArr: [], //入班血月列表

      //更多学员入班
      Current_campus_id: '', //当前班级的所属校区id
      gridData: [],
      gridData2: [], //插入的学员
      form3: {
        realname: '',
        leader: '',
        phone_a_num: '',
        normal_state: '',
      },

      //调班参数
      outerVisible2: false,
      stuChange_ClassList: [],
      target_change_class: {},
      current_student_id: '',
      current_student: {}, //当前学员

      changeform: {
        className: '',
        curriculum_id: '',
        now_class_id: '',
      },

      page_no4: 1,
      page_size4: 10,
      total4: 0,
      page_no5: 1,
      page_size5: 20,
      total5: 0,
      campusId: '',
    }
  },

  watch: {
    '$store.state.user.selected_schools': {
      handler(newValue) {
        console.log('校区监听')

        if (newValue.length == 0) {
          this.$message.warning('请选择校区')
        } else {
          this.getClassesList()
        }

        if (newValue.length == 1) {
          this.getCampusSubjectList()
          this.getCampusTeacherList()
        } else {
          this.subjectList = []
          this.teacherList = []

          this.ruleForm.subject_id = ''
          this.ruleForm.lecturer_id = ''
        }
      },
      deep: true,
    },
  },
  async mounted() {
    const cacheData = window.sessionStorage.getItem('classManagementCacheData')
    if (cacheData) {
      Object.assign(this.$data, JSON.parse(cacheData))
      window.sessionStorage.removeItem('classManagementCacheData')
    }
    if (this.$store.state.user.selected_schools.length == 0) {
      return this.$message.warning('请选择校区')
    }
    await this.getTeacherListByCampusIds()
    this.getClassesList()
    if (this.$store.state.user.selected_schools.length == 1) {
      this.getCampusSubjectList()
      // this.getCampusTeacherList()
    }

    this.getEducationalInstitutionCampusList() //获取分校列表
    this.getCampusArrSubjectList()
  },
  methods: {
    getCampusArrSubjectList() {
      getCampusArrSubjectList({
        campusIdArr: JSON.stringify(this.$store.state.user.selected_schools),
      }).then((res) => {
        console.log(res, 123456)
        this.subjectList1 = res.campusSubjectList
      })
    },
    //获得教师列表
    async getTeacherListByCampusIds() {
      return api_eduCampusSelectTchListByCampus({
        // campusIds: JSON.stringify(this.$store.state.user.selected_schools),
        eduCampusIdList: this.$store.state.user.selected_schools,
        subjectId: this.ruleForm.subject_id,
        curriculumId: this.ruleForm.curriculum_id,
      }).then((res) => {
        console.log(res, 12345678945)
        this.teacherList1 = res
        // this.tchList = res.campusTchList
        if (this.$attrs.methodAuthTabView('在读班级', '查询') && this.$attrs.methodAuthTabView('在读班级', '查询').viewScope === 1) {
          this.ruleForm.lecturer_id = this.$store.state.user.userInfo.id
        }
      })
    },
    Topping(row) {
      this.tagList1.splice(this.tagList1.indexOf(row), 1)
      this.tagList1.unshift(row)
      this.tagList1.map((item) => {
        item.tag = '次'
      })
      this.tagList1[0].tag = '主'
    },
    detaile(row, index) {
      console.log(row, index)
      // 1、先检查所选项的列表中有没有一样的，如果有的话直接删除
      const havaExcess = this.tagList1.filter(item => item.id === row.id);
      if (havaExcess.length > 1) {
        this.tagList1.splice(index, 1)
      } else {
        // 2、如果没有一样的，也就是说当前所选项是唯一的，那就走判断逻辑，满足判断逻辑的给出提示，
        // 3、如果不满足判断条件的话也要调接口删除掉
        const havaData = this.tableDataCourse.find(item => item.id === row.id);
        if (havaData) {
          checkReomveXmGoods({
            curriculum_class_id: this.CurrentSelectClassId,
            xm_goods_id: row.id,
          }).then((res) => {
            console.log(res)
            console.log(res.isHaveStuCostByThisXmGoods, 54611)
            // 如果是消耗课程，则提示
            if (res.isHaveStuCostByThisXmGoods === true) {
              this.$confirm(
                '以下学员已指定此课程为消耗课程，请在“班级管理中”移出学员或更改学员消耗方式后再操作!',
                '提示',
                {
                  confirmButtonText: '关闭',
                  type: 'warning',
                }
              ).then(() => { })
            } else { // 否则删除课程
              havaData.isShow = false
              // this.tagList1.splice(this.tagList1.indexOf(row), 1)
              this.tagList1.splice(index, 1)
            }
          })
        } else {
          this.tagList1.splice(index, 1)
        }
        // this.tableDataCourse.map((item) => {
        //   if (item.id === row.id) {
        //     console.log(232)
        //     // 检测学员是否已指定此课程为消耗课程
        //     checkReomveXmGoods({
        //       curriculum_class_id: this.CurrentSelectClassId,
        //       xm_goods_id: row.id,
        //     }).then((res) => {
        //       console.log(res)
        //       console.log(res.isHaveStuCostByThisXmGoods, 54611)
        //       // 如果是消耗课程，则提示
        //       if (res.isHaveStuCostByThisXmGoods === true) {
        //         this.$confirm(
        //           '以下学员已指定此课程为消耗课程，请在“班级管理中”移出学员或更改学员消耗方式后再操作!',
        //           '提示',
        //           {
        //             confirmButtonText: '关闭',
        //             type: 'warning',
        //           }
        //         ).then(() => { })
        //       } else { // 否则删除课程
        //         item.isShow = false
        //         // this.tagList1.splice(this.tagList1.indexOf(row), 1)
        //         this.tagList1.splice(index, 1)
        //       }
        //     })
        //   }
        // })
      }
    },
    changecheckox(checked, row) {
      console.log(checked)
      console.log(row, 4568945)
      if (row.isShow === true) {
        this.tagList1.push(row)
      }
      this.tagList1.map((item) => {
        item.tag = '次'
      })
      this.tagList1[0].tag = '主'
      console.log(this.tagList1, 545463)
      if (row.isShow === false) {
        console.log(232)
        checkReomveXmGoods({
          curriculum_class_id: this.CurrentSelectClassId,
          xm_goods_id: row.id,
        }).then((res) => {
          console.log(res)
          console.log(res.isHaveStuCostByThisXmGoods, 54611)
          if (res.isHaveStuCostByThisXmGoods === true) {
            this.$confirm(
              '以下学员已指定此课程为消耗课程，请在“班级管理中”移出学员或更改学员消耗方式后再操作！',
              '提示',
              {
                confirmButtonText: '关闭',
                type: 'warning',
              }
            ).then(() => { })
            row.isShow = !checked
          } else {
            this.tagList1.map((item) => {
              if (item.id === row.id) {
                this.tagList1.splice(this.tagList1.indexOf(item), 1)
              }
            })
          }
        })
      }
    },
    searchCourseList() {
      this.page_no = 7
      this.getXmGoodsListForClassEdit()
    },
    getXmGoodsListForClassEdit() {
      getXmGoodsListForClassEdit({
        campusId: this.campusId,
        name: this.searchCourse,
        page_no: this.page_no7,
        page_size: this.page_size7,
      }).then((res) => {
        this.total7 = res.total
        res.xmGoodsObj.map((item) => {
          item.isShow = false
        })
        this.tableDataCourse = res.xmGoodsObj
        if (this.tagList1.length != 0) {
          this.tagList1.map((item) => {
            this.tableDataCourse.map((item1) => {
              if (item.id === item1.id) {
                item1.isShow = true
              }
            })
          })
        }

        console.log(this.tableDataCourse, 545463)
      })
    },
    handleCurrentChange7(val) {
      this.page_no7 = val
      this.getXmGoodsListForClassEdit()
    },
    showCourse() {
      this.getXmGoodsListForClassEdit()
      this.dialogVisible = true
    },
    handleInput2(e) {
      // 通过正则过滤小数点后两位
      e.target.value = e.target.value.match(/^\d*(\.?\d{0,1})/g)[0] || null
    },
    changesubject() {
      this.ruleForm.curriculum_id = ''
      this.getCampusCurriculumtListByPage()
      this.search()
    },

    changesubject1() {
      this.getCampusCurriculumtListByPage()
      this.searchHistory()
    },

    //切换
    handleClick(val) {
      console.log(val)
      if (val.index === '0') {
        this.getClassesList()
      }
      if (val.index === '1') {
        this.getHistoryClassesList()
      }
    },
    //删除上课时间
    DeleteTime(index) {
      console.log('删除上课时间段')
      console.log(index)
      this.updateform.weeksinfo.splice(index, 1)
      this.updateform.time_strs.splice(index, 1)
      console.log(this.updateform.weeksinfo)
      console.log(this.updateform.time_strs)
    },

    //增加上课时段
    AddTime() {
      var weekinfo = { type: '1', label: '周一' }
      this.updateform.weeksinfo.push(weekinfo)
      var timeinfo = { start_date: '08:00', end_date: '20:00' }
      this.updateform.time_strs.push(timeinfo)
    },

    //改变搜索条件
    ChangeSearchState() {
      this.moresearch = !this.moresearch
    },

    getCurriculumList(val) {
      this.ruleForm.curriculum_id = ''
      getCurriculumList({
        subject_id: val,
        page_size: 100,
      }).then((res) => {
        console.log('课程体系列表')
        console.log(res.curriculum_list)
        this.curriculum_list = res.curriculum_list
      })
    },

    //TODO
    //获取学校公开课课程体系
    getCampusCurriculumtListByPage() {
      this.curriculum_list = []

      console.log('获取学校课程体系')
      console.log(this.ruleForm)

      getCampusCurriculumtListByPage({
        campusIds: JSON.stringify(this.$store.state.user.selected_schools),
        subjectId: this.ruleForm.subject_id,
        teaching_type: '',
        curriculum_type: '',
        page_no: 1,
        page_size: 100,
      }).then((res) => {
        console.log('获取学校课程体系列表')
        console.log(res)
        this.curriculum_list = res.campusAuthList
      })
    },

    search() {
      this.page_no = 1
      this.getClassesList()
    },

    search1() {
      this.page_no4 = 1
      this.getClassListForStuChangeClass(this.current_student)
    },

    search3() {
      this.page_no3 = 1
      this.getFormalStudentList()
    },

    getEducationalInstitutionCampusList() {
      getEducationalInstitutionCampusList().then((res) => {
        console.log('获得分校列表')
        console.log(res)
        this.school_list = res.educational_institution_campus_list
      })
    },

    //获取学校公开课课程体系
    getCampusCurriculumtList() {
      getCampusCurriculumtList({
        campusId: this.updateform.educational_institution_campus_id,
        subjectId: this.updateform.subject_id,
        teaching_type: this.updateform.teaching_type,
        class_type: '',
      }).then((res) => {
        console.log('获取学校科目下全部课程')
        console.log(res)
        this.curriculum_list_class = res.campusCurriculumList
      })
    },
    searchHistory() {
      this.getHistoryClassesList()
    },

    // 获取结业班级列表
    getHistoryClassesList() {
      getClassesList({
        campusIds: JSON.stringify(this.$store.state.user.selected_schools),
        curriculum_class_type: this.ruleForm.course_state,
        className: this.ruleForm.classname,
        lecturer_id: this.ruleForm.lecturer_id,
        subject_id: this.ruleForm.subject_id,
        curriculum_id: this.ruleForm.curriculum_id,
        teaching_type: this.ruleForm.teaching_type,
        class_start_time_begin: this.ruleForm.startdate
          ? this.ruleForm.startdate[0]
          : null,
        class_start_time_end: this.ruleForm.startdate
          ? this.ruleForm.startdate[1]
          : null,

        class_end_time_begin: this.ruleForm.enddate
          ? this.ruleForm.enddate[0]
          : null,
        class_end_time_end: this.ruleForm.enddate
          ? this.ruleForm.enddate[1]
          : null,
        end_class_state: 1,
        page_no: this.page_no5,
        page_size: this.page_size5,
      }).then((res) => {
        this.tableData3 = res.class_list
        this.total5 = res.total

        console.log('查询班级列表')
        console.log(res)
      })
    },

    // 获取班级列表
    getClassesList() {
      console.log('this.ruleForm.value1')
      console.log(this.ruleForm.value1)

      getClassesList({
        week_json: JSON.stringify(this.ruleForm.typetime),
        campusIds: JSON.stringify(this.$store.state.user.selected_schools),
        curriculum_class_type: this.ruleForm.course_state,
        className: this.ruleForm.classname,
        lecturer_id: this.ruleForm.lecturer_id,
        subject_id: this.ruleForm.subject_id,
        curriculum_id: this.ruleForm.curriculum_id,
        teaching_type: this.ruleForm.teaching_type,
        class_start_time_begin: this.ruleForm.startdate
          ? this.ruleForm.startdate[0]
          : null,
        class_start_time_end: this.ruleForm.startdate
          ? this.ruleForm.startdate[1]
          : null,

        class_end_time_begin: this.ruleForm.enddate
          ? this.ruleForm.enddate[0]
          : null,
        class_end_time_end: this.ruleForm.enddate
          ? this.ruleForm.enddate[1]
          : null,
        end_class_state: 0,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        this.tableData = res.class_list
        this.total = res.total

        console.log('查询班级列表')
        console.log(res)
      })
    },

    //更新班级信息
    updateClasses() {
      if (this.is_cost_lesson_hour == '1') {
        if (this.inputValue == '' || this.inputValue < 1) {
          this.$message.warning('消耗课时不能为空或不能小于1')
          return false
        }
      }
      let xmGoodsArr = []
      if (this.tagList1.length != 0) {
        this.tagList1.map((item) => {
          if (item.tag === '主') {
            xmGoodsArr.push({
              xm_goods_id: item.id,
              is_main: '1',
            })
          } else {
            xmGoodsArr.push({
              xm_goods_id: item.id,
              is_main: '0',
            })
          }
        })
      }
      console.log('更新班级参数')
      console.log(this.updateform)

      var time_quantum = []

      for (let k = 0; k < this.updateform.weeksinfo.length; k++) {
        var quantum = {
          type: this.updateform.weeksinfo[k].type,
          start_date: this.updateform.time_strs[k].start_date,
          end_date: this.updateform.time_strs[k].end_date,
        }
        time_quantum.push(quantum)
      }

      console.log('班级信息提交的参数')
      console.log(time_quantum)

      updateClasses({
        classId: this.updateform.id,
        name: this.updateform.name,
        subject_id: this.updateform.subject_id,
        curriculum_id: this.updateform.curriculum_id,
        educational_institution_campus_id: this.updateform
          .educational_institution_campus_id,
        teaching_type: this.updateform.teaching_type,
        lecturer_id: this.updateform.lecturer_id,
        assistant_teacher_id: this.updateform.assistant_teacher_id,
        curriculum_class_type: this.updateform.curriculum_class_type,

        time_quantum: JSON.stringify(time_quantum),
        lesson_hour: this.inputValue,
        xmGoodsArr: JSON.stringify(xmGoodsArr),
        is_cost_lesson_hour: this.is_cost_lesson_hour,
      }).then((res) => {
        console.log('更新班级')
        console.log(res)
        if (res.is_update) {
          this.$message.success('修改成功')
          this.dialogFormVisible7 = false
          this.getClassesList()
        }
      })
    },

    reSize(formName) {
      this.classStartTime = ''
      this.search_type = ''
      this.ruleForm.search_value = ''
      this.$refs[formName].resetFields()
      this.getClassesList()
    },

    lookClasses(row) {
      this.handleCacheData();
      this.$router.push({
        name: 'look-class-info',
        query: {
          class_code: row.class_code,
        },
      })
    },

    courseArranging(row) {
      this.handleCacheData();
      sessionStorage.setItem('courseArranging', JSON.stringify(row)),
        this.$router.push({
          name: 'divide-class1',
          query: {
            paike: 'second',
            class_code: row.class_code,
            id: row.id,
            curriculum_id: row.curriculum_id,
            campus_id: row.educational_institution_campus_id,
          },
        })
    },

    //取消结业
    updateClassesEndClassState1(row) {
      this.$confirm('是否取消结业', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          updateClassesEndClassState({
            class_id: row.id,
            end_class_state: 0,
          }).then(() => {
            this.getHistoryClassesList()
            this.$message({
              type: 'success',
              message: '恢复班级成功!',
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消成功',
          })
        })
    },

    //班级结业
    updateClassesEndClassState(row) {
      this.$confirm('确定对该班级进行结业吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          updateClassesEndClassState({
            class_id: row.id,
            end_class_state: 1,
          }).then(() => {
            this.getClassesList()
            this.$message({
              type: 'success',
              message: '结业成功!',
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消结业',
          })
        })
    },
    InsertStudent(index) {
      console.log('插入学员')
      console.log(index)
      this.gridData2.push(this.gridData[index])

      this.gridData2 = this.unique(this.gridData2)
      console.log(this.gridData2)
    },

    Deleteoutputs(index) {
      this.gridData2.splice(index, 1)
    },

    //点击分班按钮
    DivideStudent(row) {
      console.log(row, 456)

      if (row.is_cost_lesson_hour === true) {
        let gooid = null
        row.classXmGoodsArr.map((item) => {
          if (item.is_main === true) {
            gooid = item.xm_goods_id
          }
        })
        sessionStorage.setItem('courseArranging', JSON.stringify(row)),
          this.handleCacheData();
        this.$router.push({
          name: 'divide-class1',
          query: {
            gooid: gooid,
            campus_id: row.educational_institution_campus_id,
            id: row.id,
            curriculum_id: row.curriculum_id,
            subject_id: row.subject_id,
            is_cost_lesson_hour: row.is_cost_lesson_hour,
            lesson_hour: row.lesson_hour,
            curriculum_class_type: row.curriculum_class_type,
            classXmGoodsArr: JSON.stringify(row.classXmGoodsArr),
            lecturer_id: row.lecturer_id,
          },
        })
      } else {
        sessionStorage.setItem('courseArranging', JSON.stringify(row)),
          this.handleCacheData();
        this.$router.push({
          name: 'divide-class1',
          query: {
            campus_id: row.educational_institution_campus_id,
            id: row.id,
            curriculum_id: row.curriculum_id,
            subject_id: row.subject_id,
            is_cost_lesson_hour: row.is_cost_lesson_hour,
            lesson_hour: row.lesson_hour,
            curriculum_class_type: row.curriculum_class_type,
            classXmGoodsArr: JSON.stringify(row.classXmGoodsArr),
            lecturer_id: row.lecturer_id,
          },
        })
      }
    },

    //已报名未分班学员
    getNotDivideStudentList() {
      getNotDivideStudentList({
        classId: this.CurrentSelectClassId,
        realname: '',
        page_no: this.page_no2,
        page_size: this.page_size2,
      }).then((res) => {
        console.log('查询已报名未分班学员')
        console.log(res)
        this.tableData2 = res.studentList

        this.total2 = res.total
      })
    },

    getClassStudentList() {
      getClassStudentList({
        classId: this.CurrentSelectClassId,
        realname: '',
        page_no: this.page_no1,
        page_size: this.page_size1,
      }).then((res) => {
        console.log('查询班级学员列表')
        console.log(res)
        this.tableData1 = res.studentList
        this.total1 = res.total
      })
    },

    //添加学员进班
    addStudentClassRelation() {
      if (this.NoClassStudents.length == 0) {
        this.$message.warning('请选择入班学员')
        return
      }

      this.studentDataArr = [] //清空学生ID组
      var studentData = {
        student_user_id: '',
        receiptGoodsId: '',
      }

      for (let k = 0; k < this.NoClassStudents.length; k++) {
        if (this.NoClassStudents[k].ClassGoodsInfo) {
          studentData = {
            student_user_id: this.NoClassStudents[k].ClassGoodsInfo
              .student_user_id,
            receiptGoodsId: this.NoClassStudents[k].ClassGoodsInfo.id,
          }
        } else {
          this.$message.warning('有学员未关联收据，请核对')
          return
        }

        this.studentDataArr.push(studentData)
      }

      console.log('添加学员参数')
      console.log(this.studentDataArr)
      console.log('班级ID')
      console.log(this.CurrentSelectClassId)

      addStudentClassRelation({
        studentDataArr: JSON.stringify(this.studentDataArr),
        curriculum_class_id: this.CurrentSelectClassId,
      }).then((res) => {
        console.log('添加学员进班')
        console.log(res)
        if (res.is_create) {
          if (res.failarr.length == 0) {
            this.$message.success('入班成功')
          } else {
            for (let k = 0; k < res.failarr.length; k++) {
              this.$notify({
                title: '警告:',
                message: res.failarr[k].failReason,
                type: 'warning',
                duration: 2000,
                offset: k * 100 + 100,
              })
            }
          }
          this.getClassStudentList()
          this.getNotDivideStudentList(this.CurrentSelectClassId)
        }
      })
    },

    //数组对象去重
    unique(arr) {
      const res = new Map()
      return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1))
    },
    //从全部学员加入班级
    addStudentClassRelationFromAll() {
      console.log('加入班级')
      console.log(this.gridData2)

      this.studentDataArr = [] //清空学生ID组
      var studentData = {
        student_user_id: '',
      }

      if (this.gridData2.length == 0) {
        this.$message.warning('请选择学员')
        return
      }

      for (let k = 0; k < this.gridData2.length; k++) {
        studentData = {
          student_user_id: this.gridData2[k].id,
        }

        this.studentDataArr.push(studentData)
      }

      addStudentClassRelation({
        studentDataArr: JSON.stringify(this.studentDataArr),
        if_add_receipt_info: '0',
        curriculum_class_id: this.CurrentSelectClassId,
      }).then((res) => {
        console.log('添加学员进班')
        console.log(res)
        if (res.is_create) {
          if (res.failarr.length == 0) {
            this.$message.success('入班成功')
            this.dialogTableVisible = false
          } else {
            for (let k = 0; k < res.failarr.length; k++) {
              this.$notify({
                title: '警告:',
                message:
                  this.gridData2[k].studentUserInfo.realname +
                  ',' +
                  res.failarr[k].failReason,
                type: 'warning',
                duration: 2000,
                offset: k * 100 + 100,
              })
            }
          }
          this.getClassStudentList()
        }
      })
    },

    //班级移除学员
    delStudentClassRelation() {
      if (this.OutClassStudents.length == 0) {
        this.$message.warning('请选择要移除的学员')
        return
      }

      console.log(this.OutClassStudents)

      this.$confirm(
        '确定要移除所选学员吗? 移除后学员所有已分配讲次清空，且本操作不可逆。',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        this.outstudentIds = [] //清空学生ID组
        for (let k = 0; k < this.OutClassStudents.length; k++) {
          this.outstudentIds.push(this.OutClassStudents[k].studentInfo.id)
        }
        console.log('移除学员参数')
        console.log(this.outstudentIds)
        console.log('班级ID')
        console.log(this.CurrentSelectClassId)

        delStudentClassRelation({
          studentIds: JSON.stringify(this.outstudentIds),
          curriculum_class_id: this.CurrentSelectClassId,
        }).then((res) => {
          console.log('班级移除学员')
          console.log(res)
          if (res.is_delete) {
            if (res.failArr.length == 0) {
              this.$message.success('移除成功')
            } else {
              for (let k = 0; k < res.failArr.length; k++) {
                this.$notify({
                  title: '警告:',
                  message:
                    this.OutClassStudents[k].studentInfo.studentUserInfo
                      .realname +
                    ',' +
                    res.failArr[k].msg,
                  type: 'warning',
                  duration: 4000,
                  offset: k * 100 + 100,
                })
              }
            }

            this.getClassStudentList()
            this.getNotDivideStudentList(this.CurrentSelectClassId)
          }
        })
      })
    },

    //查询所有正式学员
    getFormalStudentList() {
      getFormalStudentList({
        realname: this.form3.realname,
        leader: this.form3.leader,
        phone_a_num: this.form3.phone_a_num,
        // normal_state: "2",
        campusIds: JSON.stringify([this.Current_campus_id]),
        page_no: this.page_no3,
        page_size: this.page_size3,
      }).then((res) => {
        console.log('查询所有正式学员')
        console.log(res)
        this.gridData = res.studentList
        this.total3 = res.total
      })
    },

    //加入更多学员
    AddMoreStudent() {
      console.log('加入更多学员')
      this.dialogTableVisible = true
      this.getFormalStudentList()
    },

    handleSelectionNoClassStudent(selection) {
      this.NoClassStudents = selection
      console.log('已选未分班学员')
      console.log(this.NoClassStudents)
    },
    //移除班级的学员
    handleSelectionOutClassStudent(selection) {
      this.OutClassStudents = selection
      console.log('已选即将移除班级的学员')
      console.log(this.OutClassStudents)
    },

    editClasses(row) {
      this.handleCacheData();
      this.$router.push({
        name: 'create-class',
        query: {
          class_code: row.class_code,
        },
      })
    },
    // 单个建班
    singleCreateClass() {
      this.handleCacheData();
      this.$router.push({
        name: 'create-openclass1',
      })
    },
    copyClass(row) {
      this.handleCacheData();
      this.$router.push({
        name: 'create-openclass1',
        query: {
          classInfo: JSON.stringify(row),
        },
      })
    },

    chooseClass(val) {
      console.log('子组件传值')
      console.log(val)
      this.form1.chooseClassinfo = val
      this.curriculum_class_price = val.goods_price
      this.haschoose_class = true
    },

    changeClass(row) {
      console.log('正式学员调班')
      console.log(row)
      this.dialogFormVisible = true
      this.form1.nickname = row.nickname
      this.form1.student_user_id = row.id
      this.order_state = '5'
    },

    chooseStudent(val) {
      console.log('子组件传值-已选学员')
      console.log(val)
      this.haschoose_student = true
      this.chooseStudentInfo = val
    },

    chooseTeachPlan(val) {
      console.log('子组件传值-教学计划列表')
      console.log(val)
      this.chooseTeachPlanList = []
      this.chooseTeachPlanList = val
      this.haschoose_plan = true
      console.log(this.chooseTeachPlanList)
      this.chooseTeachPlanList.forEach((item, index) => {
        console.log(index)
        const plan_list = {
          id: item.id,
        }
        //价格
        this.teaching_plan_list.push(plan_list)
      })
      console.log('教学计划ID列表')
      console.log(this.teaching_plan_list)
    },

    //TODO UpateClassInfo
    UpateClassInfo(row) {
      this.is_cost_lesson_hour1 = row.is_cost_lesson_hour
      this.campusId = row.educational_institution_campus_id
      this.tagList1 = []
      console.log('更新班级信息')
      console.log(row, 54455123)
      this.inputValue = row.lesson_hour
      if (row.is_cost_lesson_hour === true) {
        this.is_cost_lesson_hour = '1'
      } else {
        this.is_cost_lesson_hour = '0'
      }

      if (row.classXmGoodsArr.length != 0) {
        // this.tagList1
        row.classXmGoodsArr.map((item) => {
          if (item.is_main === true) {
            item.xmGoodsInfo.tag = '主'
          } else {
            item.xmGoodsInfo.tag = '次'
          }
          this.tagList1.push(item.xmGoodsInfo)
        })
      }
      // row.curriculum_class_type.toString();
      // console.log(row.curriculum_class_type.toString(), 369852)
      console.log(typeof row.curriculum_class_type, 555)

      this.updateform.curriculum_class_type = row.curriculum_class_type

      this.dialogFormVisible7 = true
      this.activeName1 = 'first'
      this.updateform.id = row.id

      this.CurrentSelectClassId = row.id

      this.updateform.educational_institution_campus_id =
        row.educational_institution_campus_id
      this.updateform.teaching_type = row.teaching_type
      this.updateform.curriculum_id = row.curriculum_id
      this.updateform.lecturer_id = row.lecturer_id
      this.updateform.assistant_teacher_id = row.assistant_teacher_id
      this.updateform.name = row.name
      this.updateform.subject_id = row.subject_id
      this.updateform.start_date = row.start_date

      this.updateform.weeksinfo = []
      this.updateform.time_strs = []

      //解析星期
      if (row.week_str) {
        for (let k = 0; k < row.week_str.split(',').length; k++) {
          console.log('星期')
          console.log(row.week_str.split(',')[k])
          var week = { type: '', label: '' }
          if (row.week_str.split(',')[k] == '周一') {
            week.type = '1'
            week.label = '周一'
          } else if (row.week_str.split(',')[k] == '周二') {
            week.type = '2'
            week.label = '周二'
          } else if (row.week_str.split(',')[k] == '周三') {
            week.type = '3'
            week.label = '周三'
          } else if (row.week_str.split(',')[k] == '周四') {
            week.type = '4'
            week.label = '周四'
          } else if (row.week_str.split(',')[k] == '周五') {
            week.type = '5'
            week.label = '周五'
          } else if (row.week_str.split(',')[k] == '周六') {
            week.type = '5'
            week.label = '周六'
          } else if (row.week_str.split(',')[k] == '周日') {
            week.type = '0'
            week.label = '周日'
          }

          this.updateform.weeksinfo.push(week)
        }
      }

      //解析时间
      if (row.time_str) {
        for (let k = 0; k < row.time_str.split(',').length; k++) {
          var time = {
            start_date: row.time_str.split(',')[k].split('-')[0],
            end_date: row.time_str.split(',')[k].split('-')[1],
          }
          this.updateform.time_strs.push(time)
        }
      }

      this.getUserCampusList()
      this.getCampusSubjectList()
      this.getCampusCurriculumtList()
      this.getCampusTeacherList()
    },

    // 获取校区
    getUserCampusList() {
      getUserCampusList().then((res) => {
        this.schoolList = res.userDeptList
      })
    },

    //获取学校科目权限列表
    getCampusSubjectList() {
      console.log('校区ID')
      console.log(this.updateform)
      getCampusSubjectList({
        campusId: this.$store.state.user.selected_schools[0],
      }).then((res) => {
        this.subjectList = res.campusSubjectList
        console.log('获取学校科目权限列表')
        console.log(res)
      })
    },

    // 具有科目权限及课程体系的老师
    getCampusTeacherList() {
      api_eduCampusSelectTchListByCampus({
        eduCampusIdList: [this.updateform.educational_institution_campus_id],
        subjectId: this.updateform.subject_id,
        curriculumId: this.updateform.curriculum_id,
      }).then((res) => {
        console.log('具有科目权限及课程体系的老师')
        console.log(res)
        this.teacherList = res //主讲老师
        if (this.$attrs.methodAuthTabView('在读班级', '查询') && this.$attrs.methodAuthTabView('在读班级', '查询').viewScope === 1) {
          this.updateform.lecturer_id = this.$store.state.user.userInfo.id
        }
      })
    },

    handleCurrentChange5(val) {
      this.page_no5 = val
      this.getHistoryClassesList()
    },
    handleSizeChange5(val) {
      this.page_size5 = val
      this.getHistoryClassesList()
    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.page_size = val
      this.getClassesList()
    },

    handleSizeChange3(val) {
      this.page_size3 = val
      this.getFormalStudentList()
    },

    handleCurrentChange(val) {
      this.page_no = val
      this.getClassesList()
    },

    handleCurrentChange1(val) {
      this.page_no1 = val
      this.getClassStudentList() //查询班级学员列表
    },

    handleCurrentChange2(val) {
      this.page_no2 = val
      this.getNotDivideStudentList()
    },

    handleCurrentChange3(val) {
      this.page_no3 = val
      this.getFormalStudentList()
    },

    handleCurrentChange4(val) {
      this.page_no4 = val
      this.getClassListForStuChangeClass(this.current_student)
    },

    //选择班级
    handleSelectionChange(selection) {
      this.chooseClassses = selection
      console.log('选择的班级列表')
      console.log(this.chooseClassses)
    },
    //删除班级
    delClasses(row) {
      this.dialogVisible3 = true
      this.inputTxt = ''
      this.classIds = []
      this.delName = ''
      this.classIds.push(row.id)
      this.delName = row.name
    },
    delSubmit() {
      // name: this.delName,
      api_currClsDelete(this.classIds).then(() => {
        this.dialogVisible3 = false
        this.$message.success('删除成功')
        this.getClassesList()
      })
    },

    //查看收据
    LookReceipt(row) {
      if (!row) {
        this.$message.warning('请关联收据，再查看.')
        return
      }

      console.log('查看收费收据')

      this.getReceiptChargeGoodsList(row)
    },

    //查询收据商品
    getReceiptChargeGoodsList(row) {
      this.DialogVisible = true
      console.log('查询收据详情')
      console.log(row)
      this.getCampusUserList()
      this.Current_Receipt = row
      this.goods_and_course_price = 0
      this.updateform.id = row.id
      this.updateform.bill_code = row.bill_code
      this.updateform.leader = row.leader
      this.updateform.educational_institution_campus_id =
        row.educational_institution_campus_id
      this.updateform.remark = row.remark
      this.updateform.charge_type = row.charge_type

      this.ReceiptData = []
      getReceiptChargeGoodsList({
        receipt_id: row.id,
      }).then((res) => {
        console.log('查询收据对应的商品')
        console.log(res)
        this.ReceiptData = res.receiptChargeGoodsList

        for (let k = 0; k < res.receiptChargeGoodsList.length; k++) {
          console.log(res.receiptChargeGoodsList[k].total_amount)
          this.goods_and_course_price =
            this.goods_and_course_price +
            res.receiptChargeGoodsList[k].total_amount
        }
      })
      //查询收据对应的账号
      getReceiptAccountList({
        receipt_id: row.id,
      }).then((res) => {
        console.log('查询收据对应的账户')
        console.log(res)
        this.receiptAccountList = res.receiptAccountList
      })
    },

    //获得校区员工列表
    getCampusUserList() {
      getCampusUserList({
        campusId: this.$store.state.user.selected_schools[0],
      }).then((res) => {
        console.log('获得学校用户列表')
        console.log(res)
        this.user_list = res.campusUserList
      })
    },

    //可调入班级列表
    getClassListForStuChangeClass(row) {
      console.log('调班学员')

      console.log(row)
      this.current_student = row
      this.current_student_id = row.student_user_id

      getClassListForStuChangeClass({
        educational_institution_campus_id: this.updateform
          .educational_institution_campus_id,
        curriculum_id: this.updateform.curriculum_id,
        now_class_id: this.CurrentSelectClassId,
        className: this.changeform.className,
        lecturer_id: '',
        page_no: this.page_no4,
        page_size: this.page_size4,
      }).then((res) => {
        console.log('查询可调入班级')
        console.log(res)
        this.outerVisible2 = true
        this.stuChange_ClassList = res.classList
        this.total4 = res.total
      })
    },

    //目标调入班级选择
    SelectTargetClass(val) {
      console.log('选择了目标调入班级')
      console.log(val)
      this.target_change_class = val
    },

    //调班接口
    changeStuClass() {
      console.log('调班操作')
      changeStuClass({
        student_user_id: this.current_student_id,
        now_class_id: this.CurrentSelectClassId,
        change_class_id: this.target_change_class.id,
      }).then((res) => {
        console.log('调班接口')
        console.log(res)
        if (res.is_change) {
          this.$message.success('调班成功')
          this.outerVisible2 = false
          this.getClassStudentList()
        }
      })
    },
    handleCacheData() {
      window.sessionStorage.setItem('classManagementCacheData', JSON.stringify(this.$data));
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/ .el-divider--horizontal {
  margin: 0;
  margin-bottom: 20px;
}

.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;
  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.45);
  }
}

.class-management {
  height: 100%;
  margin: 10px;
  padding-top: 10px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  background-color: #fff;

  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
    font-size: 12px;
    padding-right: 5px;
    padding-left: 10px;
  }

  .setting {
    float: right;
  }
}

.delWaring {
  color: #ca2f2d;
  font-weight: bold;
  font-size: 18px;
  border: 2px solid #ca2f2d;
  padding: 15px;
  background: #ffe8e6;
  border-radius: 5px;
}

.delWaring1 {
  color: #ca2f2d;
  font-size: 18px;
  border: 2px solid #ca2f2d;
  padding: 15px;
  background: #ffe8e6;
  border-radius: 5px;
  margin-top: 20px;
}
</style>

<style>
.class-management .el-table .warning-row {
  background: oldlace;
}

.class-management .el-table .success-row {
  background: #f0f9eb;
}

.class-management .el-dialog__body {
  padding: 20px 20px;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.isShowClass {
  display: inline-block;
  margin-right: 10px;
  display: none;
}

.showTopping:hover {
  background: #f3f6fb;
}

.showTopping:hover .isShowClass {
  display: inline-block;
}

/deep/.el-dialog {
  border-radius: 10px !important;
}
</style>
